import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { ADD_SUBSCRIPTION_ERROR, ADD_SUBSCRIPTION_REQUEST, ADD_SUBSCRIPTION_SUCCESS } from '../types';
import { useHelper } from '../helpers';
export var addSubscriptionRequest = function addSubscriptionRequest(sku) {
  return {
    type: ADD_SUBSCRIPTION_REQUEST,
    sku: sku
  };
};
export var addSubscriptionSuccess = function addSubscriptionSuccess(cart, lineItem, subscriptionLineItem) {
  return {
    type: ADD_SUBSCRIPTION_SUCCESS,
    data: cart,
    lineItem: lineItem,
    subscriptionLineItem: subscriptionLineItem
  };
};
export var addSubscriptionError = function addSubscriptionError(error) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: ADD_SUBSCRIPTION_ERROR,
    error: true,
    meta: meta,
    payload: error
  };
};
export var addSubscription = function addSubscription(subscription) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var chord, _useHelper, withCart, sku, quantity, interval, endDate, input, updatedCart, lineItem, subscriptionLineItem;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            chord = _ref.chord;
            _useHelper = useHelper(dispatch, getState), withCart = _useHelper.withCart;
            sku = subscription.sku, quantity = subscription.quantity, interval = subscription.interval, endDate = subscription.endDate;
            _context.prev = 3;
            dispatch(addSubscriptionRequest(sku));
            input = {
              lineItem: {
                sku: sku,
                quantity: quantity
              },
              subscriptionLineItem: {
                intervalLength: interval.length,
                intervalUnits: interval.unit,
                endDate: endDate
              }
            };
            _context.next = 8;
            return withCart(chord.oms.addLineItem)(null, input);
          case 8:
            _context.next = 10;
            return withCart(chord.oms.getOrder)();
          case 10:
            updatedCart = _context.sent;
            lineItem = updatedCart.lineItems.find(function (li) {
              return li.variant.sku === sku;
            });
            subscriptionLineItem = lineItem.subscriptionLineItems.at(-1);
            dispatch(addSubscriptionSuccess(updatedCart, lineItem, subscriptionLineItem));
            return _context.abrupt("return", updatedCart);
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);
            dispatch(addSubscriptionError(_context.t0, {
              sku: sku,
              quantity: quantity,
              interval: interval,
              endDate: endDate
            }));
            throw _context.t0;
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 17]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};